import DynamicService from '@/service/DynamicService';
import UserSchema from '../schemas/UserSchema';
import { typeUser } from '@/utils/options';
import { getText } from '@/utils';

const formatResponse = (item) => {
  item.type_formatted = getText(typeUser, item.type);
};

const UsersService = DynamicService('users', UserSchema, { formatResponse });

export default UsersService;